import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { ActivatedRoute } from '@angular/router';
import { Checklist, DataTablesSettings, TipoRevision } from 'src/app/types/type';
import { CrudHttp } from 'src/app/helpers/CrudHttp';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { MasterDB } from 'src/app/DAO/MasterDB';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
declare var $: any;

@Component({
  selector: 'app-checklist-configuracion',
  templateUrl: './checklist-configuracion.component.html',
  styleUrls: ['./checklist-configuracion.component.css']
})
export class ChecklistConfiguracionComponent implements OnInit {
  idTipoRevision: number;
  tipoRevision: TipoRevision;
  crud: CrudHttp;
  title: string;
  subtitle: string;
  source: Checklist[];
  subMenus: { active: boolean; child: boolean; label: string; router: string; class: string; }[];
  dtOptions: DataTablesSettings;
  showContent: boolean;
  nombreNewCheckList: string;
  idCheckListC: number;
  isDeleteChecklist = false;

  constructor(private congiService: ConfiguracionService, private http: HttpClient, private activatedRoute: ActivatedRoute) {
    this.idTipoRevision = parseInt(this.activatedRoute.snapshot.params.id);
    let crud = new CrudHttp(this.http);
    crud.methodGet = 'GetChecklistsTipoRevision?idTipoRevision=' + this.idTipoRevision;
    crud.methodPost = '';
    crud.methodPut = 'UpdateStatusChecklist';
    crud.methodDelete = '';
    this.crud = crud;
    this.title = 'Listado de checklists';
    this.showContent = false;
    this.idCheckListC = 0;
    this.nombreNewCheckList = '';
  }

  ngOnInit() {
    this.loadSubMenu();
    this.dataBind();
    this.congiService.getTipoRevision(this.idTipoRevision)
      .subscribe(data => {
        if (data.Result.Exito)
          this.tipoRevision = data.Result.Data as TipoRevision
      });

    $("#modalEditRevision").on("shown.bs.modal", function () {
      let idestacion = localStorage['IdEstacionEdit'];
      localStorage.removeItem('IdEstacionEdit');
      $('#ddlEstacionesEdit').val(idestacion);
    });
  }

  dataBind() {
    this.congiService.getChecklistTipoRevision(this.idTipoRevision)
      .subscribe(resp => {
        if (resp?.Result?.Exito) {
          this.source = resp.Result.Data as Checklist[];
        }
      });
  }

  duplicarClick(id: number) {
    this.idCheckListC = id;
    $('#modalNombreCheckList').modal('show');
  }

  checklistDuplicado(checklistNew: Checklist) {
    this.source.push(checklistNew);
    Utilerias.hideLoaderSwal();
  }

  publishClick(checklist) {
    const found = this.source.find(item => item.IdEtapa === 3)

    if (found != undefined || found != null) {
      Utilerias.alertClient('<h2>Ya existe un checklist publicado</h2>', 'Debes desactivar el checklist actual para publicar uno nuevo.', 1)
    } else {
      Utilerias.alertConfirm('Ya no podras modificar el checklist', '<h2>¿Deseas publicar el checklist?</h2>')
        .then(res => {
          if (res.value) {
            this.crud.put({
              c: {
                IdChecklist: checklist.IdChecklist,
                IdEtapa: 3
              }
            })
              .then((res: any) => {
                for (let item of this.source) {
                  if (item.IdChecklist == res.IdChecklist) {
                    item.IdEtapa = res.IdEtapa;
                    item.Etapa = res.Etapa;
                    break;
                  }
                }
                Utilerias.showLoader(false);
              });
          }
        });
    }
  }

  cancelClick(checklist) {
    Utilerias.alertConfirm('¿Deseas cancelar el checklist?, ya no lo podras publicar nuevamente.')
      .then(res => {
        if (res.value) {
          this.crud.put({
            c: {
              IdChecklist: checklist.IdChecklist,
              IdEtapa: 1
            }
          })
            .then((res: any) => {
              for (let item of this.source) {
                if (item.IdChecklist == res.IdChecklist) {
                  item.IdEtapa = res.IdEtapa;
                  item.Etapa = res.Etapa;
                  break;
                }
              }
            });
        }
      });
  }

  deleteClick(IdChecklist: number) {
    Utilerias.alertConfirm('¿Deseas eliminar el checklist?')
      .then(res => {
        if (res.value) {
          this.isDeleteChecklist = true;
          this.congiService.updateEstatusDeleteChecklist(IdChecklist)
            .subscribe(resp => {
              if (resp.Result.Exito) {
                this.source = this.source.filter(item => item.IdChecklist !== IdChecklist);
                Utilerias.alertClient('Eliminado', 'Se ha eliminado el checklist', 2);
              } else {
                Utilerias.alertClient('Error', 'No se ha podido eliminar el checklist', 0);
              }
              this.isDeleteChecklist = false;
            });
        }
      });
  }

  frmNew(e: Event) {
    e.preventDefault();

    MasterDB.getUsuarioSesion(new EstacionesTVADB())
      .then(res => {
        let idEmpleadoSesion = res.IdEmpleado;
        let obj = {
          r: {
            Descripcion: $('#textNew').val(),
            IdEmpleadoAlta: idEmpleadoSesion,
            IdTipoRevision: parseInt($('#ddlTipoRevisiones').val()),
            IdRegion: parseInt($('#ddlRegiones').val()),
            IdEstacion: parseInt($('#ddlEstaciones').val()),
            FechaInicioPlan: $('#fechaInicioPlan').val(),
            FechaFinPlan: $('#fechaFinPlan').val()
          }
        };
        this.crud.post(obj)
          .then(() => {
            this.dataBind();
            //this.source.push(obj.t);
            Utilerias.ClearFields('#textNew|#fechaInicioPlan|#fechaFinPlan');
            $('.close').click();
          });
      })
  }

  frmEdit(e: Event) {
    e.preventDefault();
    var id = parseInt(localStorage['IdRevisionEdit']);
    let obj = {
      r: {
        IdRevision: id,
        Descripcion: $('#textEdit').val(),
        IdTipoRevision: parseInt($('#ddlTipoRevisionesEdit').val()),
        IdRegion: parseInt($('#ddlRegionesEdit').val()),
        IdEstacion: parseInt($('#ddlEstacionesEdit').val()),
        FechaInicioPlan: $('#fechaInicioPlanEdit').val(),
        FechaFinPlan: $('#fechaFinPlanEdit').val()
      }
    };
    this.crud.put(obj)
      .then(() => {
        this.dataBind();
        localStorage.removeItem('IdRevisionEdit');
        Utilerias.ClearFields('#textEdit|#fechaInicioPlanEdit|#fechaFinPlanEdit');
        $('.close').click();
      });
  }

  loadSubMenu() {
    var items = [
      {
        active: false,
        child: true,
        label: 'Tipos de revisiones',
        router: '../../../Configuracion',
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: true,
        child: false,
        label: 'Checklists',
        router: null,
        class: 'submenu__item submenu--active d-flex align-items-center'
      }];
    this.subMenus = items;
  }
}












